export default __webpack_public_path__ + "static/media/photos-primary-icon.1d78dba7.svg";